import { callErrorMsg } from 'helpers/errorMsg'
import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getPackageIdDetailApi,
  getPackageIdListApi,
  GetPackageIdParamsType,
  postGeneratePackageIdApi,
} from 'features/SupplyOrder/services/generatePackageId'
import { GeneratePackageIdFormType } from 'features/SupplyOrder/pages/GeneratePackageId/schema'

export const SLICE_NAME_GENERATE_PACEKAGE_ID = 'GENERATE_PACKAGE_ID'

export const fetchPackageIDList = createAsyncThunk(
  `${SLICE_NAME_GENERATE_PACEKAGE_ID}/fetchPackageIDList`,
  async (params: GetPackageIdParamsType, { rejectWithValue }) => {
    try {
      const { data } = await getPackageIdListApi(params)
      return data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const generatePackageID = createAsyncThunk(
  `${SLICE_NAME_GENERATE_PACEKAGE_ID}/generatePackageID`,
  async (payload: GeneratePackageIdFormType, { rejectWithValue }) => {
    try {
      const { data } = await postGeneratePackageIdApi(payload)
      return data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const fetchPackageIdDetails = createAsyncThunk(
  `${SLICE_NAME_GENERATE_PACEKAGE_ID}/fetchPackageIdDetails`,
  async (
    { date, params }: { date: string; params: GetPackageIdParamsType },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await getPackageIdDetailApi(date, params)
      return data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)
